import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=7376769a&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=7376769a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7376769a",
  null
  
)

export default component.exports